import React, {useCallback, useEffect, useState} from 'react';
import {Modal} from '../../../utils/modal/Modal';
import { flowSessionsAction } from '../../../actions/triggersAction';
import { toast } from 'react-toastify';
import { formatErrors } from '../../../constants';
import { useDispatch } from 'react-redux';
import { Pagination } from '../../../utils/pagination/Pagination';

export function TriggerSessionModal({trigger, triggerWrap = true, flowId, blockNames}) {
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const [sessions, setSessions] = useState([]);
  const [total, setTotal] = useState(0);
  const [filter, setFilter] = useState({page: 1, limit: 15, flow_id: flowId});
  const [search, setSearch] = useState('');

  const handleOpen = (value) => {
    if (loading) {
      return;
    }
    setOpen(value);
  };

  const getSessions = useCallback((filter) => {
    if (loading) {
      return;
    }
    setLoading(true);

    dispatch(flowSessionsAction(filter)).then((data) => {
      setSessions(data.list || []);
      setTotal(data.count || 0);
      setLoading(false);
    }).catch((err) => {
      setLoading(false);
      toast.error(formatErrors([err.message]), {position: toast.POSITION.BOTTOM_RIGHT});
    });
  }, []);

  const handleChangePage = useCallback((value) => {
    setFilter((data) => {
      return {...data, page: value}
    });
  }, []);

  useEffect(() => {
    if (open) {
      getSessions(filter);
    }
  }, [open]);

  // get list
  useEffect(() => {
    if (filter.page) {
      getSessions(filter);
    }
  }, [filter, getSessions]);

  const handleSearch = (value) => {
    setSearch(value);
    setFilter({...filter, search: value, page: 1});
  };


  return <Modal isStatic={true} open={open} handleOpen={handleOpen} trigger={trigger} triggerWrap={triggerWrap} isWide={true}>
    <React.Fragment>
      <div className="modal__title">История запусков</div>

      <div style={{marginTop: '10px'}}>
        <input type="text" style={{width: '250px'}}
                          name="name"
                          className="input"
                          placeholder="Введите название"
                          value={search}
                          disabled={loading}
                          onChange={(e) => setSearch(e.target.value)}/>
        <button className="btn" onClick={() => handleSearch(search)} style={{padding: 8, maxWidth: 80, marginLeft: '5px'}}>Найти</button>
        {search && <button className="btn btn-red" onClick={() => {setFilter({...filter, search: '', page: 1}); setSearch('')}} style={{padding: 8, maxWidth: 80, marginLeft: '5px'}}>Сбросить</button>}
      </div>

      <div className="sessions-table-wrapper">
        <table className="sessions-table">
          <thead>
            <tr>
              <th>Блок</th>
              <th>Клиент</th> 
              <th>Выполнено</th>
              <th>Дата</th>
            </tr>
          </thead>
          <tbody className="sessions-table__body">
            {(sessions || []).map((session) => (
              <tr key={session.id}>
                <td>{blockNames[session.block_id] || session.block_id}</td>
                <td><span style={{cursor: 'pointer'}} onClick={() => handleSearch(session.client_name)}>{session.client_name}</span>&nbsp;
                    <small style={{cursor: 'pointer'}} onClick={() => handleSearch(session.phone)}>{session.phone}</small></td>
                <td>{session.ready ? "Да" : "Нет"}</td>
                <td>{session.created}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {filter.page && filter.page > 0 && <Pagination page={filter.page} total={total} limit={filter.limit} onChange={handleChangePage}/>}
     
      <button type="button" className="modal__btn modal__btn--cancel btn" disabled={loading} onClick={() => handleOpen(false)}>Закрыть</button>
    </React.Fragment>
  </Modal>
};
